import { render, staticRenderFns } from "./ShipmentNomenclature.vue?vue&type=template&id=1f697a94&scoped=true&"
import script from "./ShipmentNomenclature.vue?vue&type=script&lang=js&"
export * from "./ShipmentNomenclature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f697a94",
  null
  
)

export default component.exports